import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is handled entirely via httpOnly cookies (access_token for JWT, session_token
// for the Emergent Google flow). withCredentials makes axios send them on every call.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 402 handler: the backend paid_access_guard middleware returns 402 with
// {code:"trial_expired"} when a write action is attempted after the free trial
// has expired. Show a single toast and nudge the user toward the billing page —
// but only if they aren't already on it, to avoid loops.
let _trialToastShown = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const code = err?.response?.data?.code;
    if (status === 402 && code === "trial_expired") {
      if (!_trialToastShown) {
        _trialToastShown = true;
        toast.error(
          err?.response?.data?.detail ||
            "Souscrivez à un abonnement pour continuer à utiliser Questiomed.",
          {
            duration: 6000,
            action: {
              label: "Souscrire",
              onClick: () => {
                window.location.href = "/settings?tab=billing";
              },
            },
            onDismiss: () => {
              _trialToastShown = false;
            },
            onAutoClose: () => {
              _trialToastShown = false;
            },
          }
        );
      }
    }
    return Promise.reject(err);
  }
);
